module.exports = __webpack_public_path__ + "static/6305-woodrose-45-f693d991e618ec0757fb260ee59ab45f.jpg";